export enum Alignment {
  CENTER = 'center',
  LEFT = 'left'
}

export type M0041Props = {
  /** Optional text alignment, defaults to center */
  alignment?: Alignment
  /** Optional background image url */
  backgroundImageUrl?: string
  /** Optional color overlay for the component */
  colorOverlay?: string
  /** Required text to be displayed as the heading */
  heading: string
  /** Option of opening in a new tab, defaults to an empty string  */
  linkTarget?: '' | '_blank' | '_self'
  /** Optional link title, can be seen when hovering over the component */
  linkTitle?: string
  /** Optional URL */
  linkUrl?: string
  /** Optional subheading text */
  subheading?: string
  /** Optional voucher code text */
  voucherCode?: string
  /** Optional legalCopy text for more information regarding the voucher code */
  legalCopy?: string
  onLinkClick?: (event?: React.MouseEvent<HTMLElement>, url?: string) => void
  type: string
}

export type M0041StyledProps = {
  colorOverlay?: string
  backgroundImage?: string
  alignment?: Alignment
}
